import { render } from "./howItWorks.ferreteria.vue?vue&type=template&id=6b711952&scoped=true"
import script from "./howItWorks.ferreteria.vue?vue&type=script&lang=js"
export * from "./howItWorks.ferreteria.vue?vue&type=script&lang=js"

import "./howItWorks.ferreteria.vue?vue&type=style&index=0&id=6b711952&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b711952"]])

export default __exports__